"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextArea = void 0;
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var react_textarea_autosize_1 = __importDefault(require("react-textarea-autosize"));
var FormField_1 = require("../FormField");
var TextArea = /** @class */ (function (_super) {
    __extends(TextArea, _super);
    function TextArea() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.textAreaRef = react_1.createRef();
        _this.focus = function () { return _this.textAreaRef.current.focus(); };
        _this.select = function () { return _this.textAreaRef.current.select(); };
        _this.handleChange = function (e) {
            if (_this.props.onChange) {
                _this.props.onChange(e, __assign(__assign({}, _this.props), { value: e.target.value }));
            }
        };
        _this.handleInput = function (e) {
            if (_this.props.onInput) {
                _this.props.onInput(e, __assign(__assign({}, _this.props), { value: e.target.value }));
            }
        };
        return _this;
    }
    TextArea.prototype.render = function () {
        var _a = this.props, autoHeight = _a.autoHeight, className = _a.className, disabled = _a.disabled, error = _a.error, onChange = _a.onChange, onInput = _a.onInput, _b = _a.rows, rows = _b === void 0 ? 3 : _b, _c = _a.maxRows, maxRows = _c === void 0 ? 16 : _c, rest = __rest(_a, ["autoHeight", "className", "disabled", "error", "onChange", "onInput", "rows", "maxRows"]);
        var inputId = this.context.labelFor;
        var TextAreaClasses = classnames_1.default('TextArea', className, {
            'TextArea--disabled': disabled,
            'TextArea--error': error,
            'TextArea--auto-height': autoHeight,
        });
        var textarea = (react_1.default.createElement("textarea", __assign({}, rest, { className: TextAreaClasses, disabled: disabled, onChange: this.handleChange, onInput: this.handleInput, rows: rows, ref: this.textAreaRef, id: this.props.id || inputId })));
        var textareaAutoHeight = (react_1.default.createElement(react_textarea_autosize_1.default, __assign({}, rest, { className: TextAreaClasses, disabled: disabled, onChange: this.handleChange, onInput: this.handleInput, minRows: rows, maxRows: maxRows, ref: this.textAreaRef, cacheMeasurements: true, id: this.props.id || inputId })));
        return autoHeight ? textareaAutoHeight : textarea;
    };
    TextArea.contextType = FormField_1.FormFieldContext;
    return TextArea;
}(react_1.Component));
exports.TextArea = TextArea;
//# sourceMappingURL=TextArea.js.map